// This file is automatically generated from ingestAssets.mjs

export type SizeType = {
	width?: number;
	height?: number;
};

export type Ratio = 'bleed' | 'tall' | 'extraWide' | 'shortWide' | 'wide' | 'square';

export type Size =
	| '12XL'
	| '11XL'
	| '10XL'
	| '9XL'
	| '8XL'
	| '7XL'
	| '6XL'
	| '5XL'
	| '4XL'
	| '3XL'
	| '2XL'
	| 'XL'
	| 'large'
	| 'medium'
	| 'small'
	| 'XS'
	| '2XS';

export type RatioMap = {
	[key in Ratio]: {
		[key in Size]: SizeType;
	};
};

export const ratioMap: RatioMap = {
	bleed: {
		'12XL': { height: 416 },
		'11XL': { height: 352 },
		'10XL': { height: 328 },
		'9XL': { height: 288 },
		'8XL': { height: 264 },
		'7XL': { height: 240 },
		'6XL': { height: 216 },
		'5XL': { height: 192 },
		'4XL': { height: 168 },
		'3XL': { height: 144 },
		'2XL': { height: 120 },
		XL: { height: 96 },
		large: { height: 72 },
		medium: { height: 48 },
		small: { height: 32 },
		XS: { height: 24 },
		'2XS': { height: 16 },
	},
	tall: {
		'12XL': { width: 312, height: 416 },
		'11XL': { width: 264, height: 352 },
		'10XL': { width: 246, height: 328 },
		'9XL': { width: 216, height: 288 },
		'8XL': { width: 198, height: 264 },
		'7XL': { width: 180, height: 240 },
		'6XL': { width: 162, height: 216 },
		'5XL': { width: 144, height: 192 },
		'4XL': { width: 126, height: 168 },
		'3XL': { width: 108, height: 144 },
		'2XL': { width: 90, height: 120 },
		XL: { width: 72, height: 96 },
		large: { width: 54, height: 72 },
		medium: { width: 36, height: 48 },
		small: { width: 24, height: 32 },
		XS: { width: 18, height: 24 },
		'2XS': { width: 12, height: 16 },
	},
	extraWide: {
		'12XL': { width: 740, height: 416 },
		'11XL': { width: 626, height: 352 },
		'10XL': { width: 583, height: 328 },
		'9XL': { width: 512, height: 288 },
		'8XL': { width: 469, height: 264 },
		'7XL': { width: 427, height: 240 },
		'6XL': { width: 384, height: 216 },
		'5XL': { width: 341, height: 192 },
		'4XL': { width: 299, height: 168 },
		'3XL': { width: 256, height: 144 },
		'2XL': { width: 213, height: 120 },
		XL: { width: 171, height: 96 },
		large: { width: 128, height: 72 },
		medium: { width: 85, height: 48 },
		small: { width: 57, height: 32 },
		XS: { width: 43, height: 24 },
		'2XS': { width: 28, height: 16 },
	},
	shortWide: {
		'12XL': { width: 624, height: 416 },
		'11XL': { width: 528, height: 352 },
		'10XL': { width: 491, height: 328 },
		'9XL': { width: 432, height: 288 },
		'8XL': { width: 396, height: 264 },
		'7XL': { width: 360, height: 240 },
		'6XL': { width: 324, height: 216 },
		'5XL': { width: 288, height: 192 },
		'4XL': { width: 252, height: 168 },
		'3XL': { width: 216, height: 144 },
		'2XL': { width: 180, height: 120 },
		XL: { width: 144, height: 96 },
		large: { width: 108, height: 72 },
		medium: { width: 72, height: 48 },
		small: { width: 48, height: 32 },
		XS: { width: 36, height: 24 },
		'2XS': { width: 24, height: 16 },
	},
	wide: {
		'12XL': { width: 555, height: 416 },
		'11XL': { width: 469, height: 352 },
		'10XL': { width: 438, height: 328 },
		'9XL': { width: 384, height: 288 },
		'8XL': { width: 352, height: 264 },
		'7XL': { width: 320, height: 240 },
		'6XL': { width: 288, height: 216 },
		'5XL': { width: 256, height: 192 },
		'4XL': { width: 224, height: 168 },
		'3XL': { width: 192, height: 144 },
		'2XL': { width: 160, height: 120 },
		XL: { width: 128, height: 96 },
		large: { width: 96, height: 72 },
		medium: { width: 64, height: 48 },
		small: { width: 43, height: 32 },
		XS: { width: 32, height: 24 },
		'2XS': { width: 21, height: 16 },
	},
	square: {
		'12XL': { width: 416, height: 416 },
		'11XL': { width: 352, height: 352 },
		'10XL': { width: 328, height: 328 },
		'9XL': { width: 288, height: 288 },
		'8XL': { width: 264, height: 264 },
		'7XL': { width: 240, height: 240 },
		'6XL': { width: 216, height: 216 },
		'5XL': { width: 192, height: 192 },
		'4XL': { width: 168, height: 168 },
		'3XL': { width: 144, height: 144 },
		'2XL': { width: 120, height: 120 },
		XL: { width: 96, height: 96 },
		large: { width: 72, height: 72 },
		medium: { width: 48, height: 48 },
		small: { width: 32, height: 32 },
		XS: { width: 24, height: 24 },
		'2XS': { width: 16, height: 16 },
	},
};
